import React from "react"
import '../components/placeCard.css'
import MapPinIcon from '../components/svg/mappin'
import EnvelopeIcon from '../components/svg/envelope'
import PhoneIcon from '../components/svg/phone'
import { Link } from "react-router-dom"

const PlaceCard = props => {
    return (
        <div className="placecard">
            <img src={props.image} alt={props.title} />
            <div className="placedetail">
                <h3>{props.title}</h3>
                <p>
                    <span className="placeicon">
                        <MapPinIcon width="20" height="20" />
                    </span>
                    {props.address}</p>
                <p>
                    <span className="placeicon">
                        <EnvelopeIcon width="20" height="20" />
                    </span>
                    <Link 
                        to="#"
                        onClick={(e) => {
                            window.location.href = props.mailId;
                            e.preventDefault();
                        }}
                    >{props.mailText}</Link></p>
                {props.phoneText && (
                    <p>
                        <span className="placeicon">
                            <PhoneIcon width="20" height="20" />
                        </span>
                        <Link
                            to="#"
                            onClick={(e) => {
                                window.location.href = props.phoneId;
                                e.preventDefault();
                            }}
                        >
                            {props.phoneText}
                        </Link>
                    </p>
                )}
            </div>
        </div>
    )
}

export default PlaceCard